const deltaOnlyContainWhitespace = (ops) =>
  ops.every(({ insert }) => typeof insert === 'string' && !insert.trim());

export default deltaOnlyContainWhitespace;
